/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useMutation } from '@apollo/client' // Npm: Apollo client.


/*
 * SIBLINGS
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import CBRRoutePlanDeleteManyMutation from './__mutation__/index.cbrRoutePlan.deleteMany.mutation'


/*
 * OBJECTS
 */
const Index = ({ passOn, onClose, refetch }) => {
  // Hook assignment.
  const [MutationCBRRoutePlanDeleteMany, MutationCBRRoutePlanDeleteManyResponse] = useMutation(CBRRoutePlanDeleteManyMutation)

  // Return Component.
  return (
    <DeleteCard onClose={onClose} disabled={MutationCBRRoutePlanDeleteManyResponse.loading} onConfirm={() => MutationCBRRoutePlanDeleteMany({ 'variables': { 'routePlanIds': passOn?.routePlanIds } }).then(i => {
      // Style Guide.
      toast(i?.data?.CBRRoutePlanDeleteMany?.message)

      // Report success.
      refetch?.()
      return onClose?.()
    }).catch(() =>
      // Style Guide.
      toast('Something went wrong please try after some time.'))} isLoading={MutationCBRRoutePlanDeleteManyResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'onClose': PropTypes.func,
  'refetch': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
